import { createContext } from 'react';

export const SitesContext = createContext(null);
